export interface SelectButtonItem {
  text: string;
  icon?: string;
  value?: any;
}
